import { render } from "./displaychoice.vue?vue&type=template&id=7186282c&scoped=true"
import script from "./displaychoice.vue?vue&type=script&lang=js"
export * from "./displaychoice.vue?vue&type=script&lang=js"

import "./displaychoice.vue?vue&type=style&index=0&id=7186282c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7186282c"]])

export default __exports__